var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"px-2 badge text-dark align-text-bottom",staticStyle:{"cursor":"pointer"},on:{"click":_vm.logout}},[_c('img',{staticClass:"img",attrs:{"src":require("../assets/user.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }